// client/src/pages/NotFound.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

function NotFound() {
    const navigate = useNavigate();
    const handleGoBack = () => {
        navigate(-1); // Navega a la página anterior
    };
    return (
        <>
            <main className=' d-grid h-100 align-items-center bg-white px-4 py-5'>
                <div className="text-center">
                    <h1 className="display-1 fw-bold">404</h1>
                    <p className="fs-3">¡Vaya! La página que buscas no existe.</p>
                    <p className="lead">Parece que has encontrado un error de ruta. No te preocupes, ¡a todos nos pasa!</p>
                    <button className="btn btn-primary" onClick={handleGoBack}>Volver atrás</button>
                </div>
            </main>
        </>
    );
}

export default NotFound;